import jwt from "jsonwebtoken";

const cert =
  "-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAw0fEHOW/kQpD0eJLgfda\npDZ15kGBhVRCm74hbepXFbtF2/Y8zrYbMn+G3dI0GILHXq6xWT86XmqBWjA6LrJl\njnInvU4+V9rOLyBpZGhOfZZyLfHj+tj3W/lJK/bbab02ZLKavAyOyeV3aFIuGcKp\n2rSlzNpkqqXVLaqDMu9JgpPPFluJz7SRfRRJ99hcuzKW757BGMqGOdzvG9jlDwbz\nd+Kth/kndFS+hWGk7xxYieOB9BiVtUWNDooM/FeGVdEztwTv71E061208Nz86FhC\n9wukmgfBa2amWFP78AQoeGfi7FoU52m43eOTFmHk7UDLoMOrHoPahw2xEfGhjjjd\nuwIDAQAB\n-----END PUBLIC KEY-----";

export default function verifyJwtToken(token: string) {
  return jwt.verify(token, cert, { algorithms: ["RS256"] });
}
